import script from "./RadiologyReportsList.vue?vue&type=script&setup=true&lang=js"
export * from "./RadiologyReportsList.vue?vue&type=script&setup=true&lang=js"

import "./RadiologyReportsList.vue?vue&type=style&index=0&id=50b73828&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50b73828"]])

export default __exports__